import { last } from 'lodash';
import { useBreakpoint } from 'components/util/BreakpointProvider';
import { classNames } from 'libs/react';
import { useEffect } from 'libs/react';
import { useMeasure } from 'libs/react';
import { useRef } from 'libs/react';
import { useState } from 'libs/react';
import { MediaGalleryItem } from 'components/media/MediaGalleryItem';
import { MediaType } from 'libs/media/MediaType';
import { React } from 'libs/react';
import './MediaGallery.scss';
/**
 * @component MediaGallery
 * @since 1.0.0
 */
export function MediaGallery(props) {
    let { style, types, medias, selected, disabled, onPress } = Object.assign({ style: 'normal', types: 'image/*, application/pdf' }, props);
    const node = useRef(null);
    const [bounds] = useMeasure(node);
    const [layout, setLayout] = useState([]);
    const [height, setHeight] = useState(0);
    const [gutter, setGutter] = useState(0);
    useEffect(() => {
        const element = node.current;
        if (element == null) {
            return;
        }
        const styles = getComputedStyle(element);
        setGutter(Math.max(parseFloat(styles.paddingTop), parseFloat(styles.paddingLeft), parseFloat(styles.paddingRight), parseFloat(styles.paddingBottom)));
    }, [bounds.width, bounds.height]);
    const { breakpoint, isAbove, isBelow, isAboveOrEqual, isBelowOrEqual } = useBreakpoint();
    useEffect(() => {
        const element = node.current;
        if (element == null) {
            return;
        }
        const layout = [];
        let height = 0;
        let minRatio = 6;
        let rowRatio = 0;
        const rowWidth = element.clientWidth - gutter * 2;
        if (isBelowOrEqual('xl')) {
            minRatio = 5;
        }
        if (isBelowOrEqual('lg')) {
            minRatio = 4;
        }
        if (isBelowOrEqual('md')) {
            minRatio = 2;
        }
        if (isBelowOrEqual('sm')) {
            minRatio = 1;
        }
        let rowNodes = [];
        let tx = gutter;
        let ty = gutter;
        if (medias) {
            medias = medias.filter((media) => matchesTypes(media.mimetype, types));
            for (const media of medias) {
                const w = media.thumbnailWidth || 200;
                const h = media.thumbnailHeight || 200;
                const r = w / h;
                rowRatio += r;
                const node = {
                    x: 0,
                    y: 0,
                    w,
                    h,
                    r,
                    media
                };
                rowNodes.push(node);
                if (rowRatio > minRatio || last(medias) == media) {
                    rowRatio = Math.max(rowRatio, minRatio);
                    const height = (rowWidth - gutter * (rowNodes.length - 1)) / rowRatio;
                    for (const cell of rowNodes) {
                        cell.x = tx;
                        cell.y = ty;
                        cell.w = height * cell.r;
                        cell.h = height;
                        tx += cell.w + gutter;
                    }
                    layout.push(...rowNodes);
                    rowRatio = 0;
                    rowNodes = [];
                    ty = gutter + ty + height;
                    tx = gutter;
                }
            }
        }
        height = ty - gutter * 2;
        setLayout(layout);
        setHeight(height);
    }, [medias, bounds.width, bounds.height, gutter]);
    const className = classNames('media-gallery', 'media-gallery--' + style, props.className);
    return (React.createElement("div", { ref: node, className: className },
        React.createElement("div", { className: "media-gallery-content", style: { height } }, layout.map((node) => (React.createElement(MediaGalleryItem, { key: node.media.id, frame: node, media: node.media, selected: (selected === null || selected === void 0 ? void 0 : selected.find((media) => media.id == node.media.id)) != null, disabled: (disabled === null || disabled === void 0 ? void 0 : disabled.find((media) => media.id == node.media.id)) != null, onPress: onPress }))))));
}
/**
 * mime-match throws on a null mimetype and does not split comma-separated
 * accept lists, which would leave the gallery blank despite a successful query.
 * @function matchesTypes
 * @since 1.0.0
 * @hidden
 */
function matchesTypes(mimetype, types) {
    if (!types) {
        return true;
    }
    if (!mimetype) {
        return true;
    }
    return types.split(',').some((type) => {
        const pattern = type.trim();
        if (!pattern) {
            return false;
        }
        try {
            return Boolean(MediaType.match(mimetype, pattern));
        }
        catch (_a) {
            return false;
        }
    });
}
